export enum ProfileTypesEnum {
  CLIENT = "ClientProfile",
  COMPANY = "CompanyProfile",
  PROFESSIONAL = "ProfessionalProfile",
  BUSINESS = "BusinessProfile",
}

export enum ProfileExperienceLevelEnum {
  BEGINNER = "BEGINNER",
  INTERMEDIATE = "INTERMEDIATE",
  EXPERT = "EXPERT",
}

export enum ProfileLanguageProficiency {
  BASIC = "Basic",
  CONVERSATIONAL = "Conversational",
  FLUENT = "Fluent",
  NATIVE = "Native or Bilingual",
}

export enum ProfileGenderEnum {
  MALE = "MALE",
  FEMALE = "FEMALE",
  NO_INFO = "N/I",
}

export enum ProfileTemplatesEnum {
  OLD = "old",
  ONE = "one",
}

export enum ProfileCompanyTypes {
  START_UP = "START UP",
  SMALL = "SMALL BUSINESS",
  LARGE = "LARGE BUSINESS",
  AGENCY = "AGENCY",
  NON_PROFIT = "NON PROFIT",
}

export enum ProfileEmployeePoolSize {
  ONE = "ONE",
  FIVE_OR_LESS = "FIVE OR LESS",
  TEN_OR_LESS = "TEN OR LESS",
  TWENTY_FIVE_OR_LESS = "TWENTY OR LESS",
  FIFTY_OR_LESS = "FIFTY OR LESS",
  HUNDRED_OR_LESS = "HUNDRED OR LESS",
  FIVE_HUNDRED_OR_LESS = "FIVE HUNDRED OR LESS",
  FIVE_HUNDRED_PLUS = "FIVE HUNDRED PLUS",
}
